import { Grid, GridColumn } from '@progress/kendo-react-grid'
import * as React from 'react'
import {connect} from 'react-redux'
import {Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap'
import * as Redux from 'redux'
import * as App from '../../app'
import { FlashMessage } from '../../components/flash-message'
import * as Link from '../../components/link'
import {Loading} from '../../components/loading'
import * as Menu from '../../components/menu'
import * as UserMenu from '../../components/menu/user-menu'
import * as RasaModal from '../../components/modal'
import * as RasaInput from '../../components/rasa-input'
import * as User from '../../components/user'
import * as Request from '../../request'
import * as Actions from './actions'
import * as Render from './render'
import './styles.css'
import * as Types from './types'
import * as Utils from './utils'

type AppProps = App.WrappedState

interface SubmitAddUserKeyProps {
  submitModal: RasaModal.Submit<Types.UserKeyModalData>
}

type AddUserModalProps =
  RasaModal.ComponentState<Types.UserKeyModalData> &
  RasaModal.DispatchState &
  SubmitAddUserKeyProps &
  AppProps

export const AddUserKeyModal =
  ({app, modal, showModal, submitModal, updateModal}: AddUserModalProps) =>
  <Modal className="modal-lg" isOpen={modal.isOpen} toggle={showModal}>
    <form className="k-form"
          onSubmit={Link.preventDefaultThen(() => submitModal(app.selectedCommunity, modal.data))}>
      <FlashMessage />
      <ModalHeader toggle={showModal}>Create Key</ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <RasaInput.RasaInput label=""
                                placeholder="Name"
                                value={modal.data.name}
                                validation={RasaInput.validateTitle(modal.data.name)}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                updateModal({name: 'name', value: e.target.value})} />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        {modal.isSubmitting ? <Loading size={Loading.Sizes.SMALL} /> : <span/>}
        <Button color="primary"
          disabled={modal.isSubmitting || !Utils.addUserKeyModalStateValid(modal.data)}
        >
          Save
        </Button>
        <Button onClick={showModal}>Cancel</Button>
      </ModalFooter>
    </form>
  </Modal>

export const AddUserModalKeyConnect = connect(
  ({app}: AppProps) => ({app}),
  {
    showModal: Actions.showAddUserKeyModal,
    submitModal: Actions.createUserKey,
    updateModal: Actions.updateAddUserKeyModalField,
  },
)(AddUserKeyModal)

interface HeaderProps {
  showAddUserKeyModal: RasaModal.Toggle,
}

const Header = ({showAddUserKeyModal, userMenu}: HeaderProps & UserMenu.WrappedState) =>
  <div>
    <FlashMessage />
    <Row className="margin-auto">
      <Col sm="12" md="10" className="text-left page-header--padding">
        <div className="page-header">
          <span className="title">User Settings</span>
          { User.hasRole(userMenu.user, User.API_ROLE) &&
            <Button
              className="secondary-button"
              onClick={showAddUserKeyModal}
              title="Generate Key">
              Generate Key
            </Button>
          }
        </div>
      </Col>
    </Row>
  </div>

const HeaderConnect = connect(
  null,
  ({
    showAddUserKeyModal: Actions.showAddUserKeyModal,
  }),
)(Header)

interface DispatchProps {
  dispatch: Redux.Dispatch<Redux.Action>,
}

type UserSettingsProps = Types.WrappedState & DispatchProps & UserMenu.WrappedState
export const UserSettingsConnect = (props: UserSettingsProps) => {
  return props.userSettings.view.isLoading ?
      <Loading center size={Loading.Sizes.LARGE} />
    :
      <div>
        <Row>
          <Col>
            <HeaderConnect userMenu={props.userMenu} />
          </Col>
        </Row>
        <AddUserModalKeyConnect modal={props.userSettings.modal} />
        <div className="r-user-settings-top-section">
          <Row>
            <Col md="2">Account Email</Col>
            <Col>{props.userSettings.data.account_email}</Col>
          </Row>
          <Row>
            <Col md="2">Account Password</Col>
            <Col>
              <Link.AnchorLink href={Menu.AUTH_FORGOT_PASSWORD_URL}>Reset Password</Link.AnchorLink>
            </Col>
          </Row>
          <Row>
            <Col md="2">Email</Col>
            <Col>{props.userSettings.data.membership_email}</Col>
          </Row>
          <Row>
            <Col md="2">First Name</Col>
            <Col>{props.userSettings.data.first_name}</Col>
          </Row>
          <Row>
            <Col md="2">Last Name</Col>
            <Col>{props.userSettings.data.last_name}</Col>
          </Row>
        </div>
        <br></br>
        { User.hasRole(props.userMenu.user, User.API_ROLE) &&
          <div>
            <Row className="margin-auto">
              <Col sm="12" md="10" className="text-left page-header--padding">
                <div className="page-header">
                  <span className="title">Keys</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <Grid data={Request.withDispatch(props.userSettings.data.keys, props.dispatch)}>
                  <GridColumn field="name" title="Name"/>
                  <GridColumn field="key" title="Key"/>
                  <GridColumn cell={Render.ResetCell} title="Reset" sortable={false} />
                </Grid>
              </Col>
            </Row>
          </div>
        }
      </div>
}

type UserSettingsState = Types.WrappedState & UserMenu.WrappedState
export const UserSettingsConnected = connect(
  ({userSettings, userMenu}: UserSettingsState) =>
    ({
      userMenu,
      userSettings,
    }),
  (dispatch: any) => ({dispatch}),
)(UserSettingsConnect)



// WEBPACK FOOTER //
// ./src/pages/user-settings/component.tsx